module.exports = __webpack_public_path__ + "img/about5.b10d28a1.png";